// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.message-thread[data-v-6c7c53c8] {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.message-thread__preview[data-v-6c7c53c8] {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.message-thread__message[data-v-6c7c53c8] {
  display: flex;
  flex-wrap: nowrap;
  align-items: flex-start;
  gap: 6px;
}
.message-thread__message-details[data-v-6c7c53c8] {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
}
.message-thread__message-body[data-v-6c7c53c8] {
  display: flex;
  width: 100%;
}
.message-thread__text[data-v-6c7c53c8] {
  color: #111827;
  font-size: 14px;
  line-height: 20px;
}
.message-thread__reply-count[data-v-6c7c53c8] {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  gap: 12px;
}
.message-thread__reply-count-text[data-v-6c7c53c8] {
  font-size: 14px;
  color: #6b7280;
  white-space: nowrap;
}
.message-thread__divider[data-v-6c7c53c8] {
  flex: 1;
  height: 1px;
  background-color: #e5e7eb;
}
.message-thread__replies[data-v-6c7c53c8] {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.message-thread__empty[data-v-6c7c53c8] {
  display: flex;
  justify-content: center;
  padding: 16px;
  color: #6b7280;
}
.message-thread__reply[data-v-6c7c53c8] {
  display: flex;
}
.message-thread__reply-container[data-v-6c7c53c8] {
  display: flex;
  flex-direction: column;
  gap: 0;
  width: 100%;
}
.message-thread__message--reply[data-v-6c7c53c8] {
  width: 100%;
}
.message-thread__editor[data-v-6c7c53c8] {
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
}
.message-thread__message[data-v-6c7c53c8],
.message-thread__reply-container[data-v-6c7c53c8] {
  padding-left: var(--6c7c53c8-\\\$getStyles\\.containerPadding);
  padding-right: var(--6c7c53c8-\\\$getStyles\\.containerPadding);
}`, "",{"version":3,"sources":["webpack://./src/SharedWeb/scripts/apps/conversations/components/message/MessageThread.vue","webpack://./MessageThread.vue"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;ACDF;ADIA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;ACDF;ADIA;EACE,aAAA;EACA,iBAAA;EACA,uBAAA;EACA,QAAA;ACDF;ADIA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,WAAA;ACDF;ADIA;EACE,aAAA;EACA,WAAA;ACDF;ADIA;EACE,cAAA;EACA,eAAA;EACA,iBAAA;ACDF;ADIA;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,SAAA;ACDF;ADIA;EACE,eAAA;EACA,cAAA;EACA,mBAAA;ACDF;ADIA;EACE,OAAA;EACA,WAAA;EACA,yBAAA;ACDF;ADIA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;ACDF;ADIA;EACE,aAAA;EACA,uBAAA;EACA,aAAA;EACA,cAAA;ACDF;ADIA;EACE,aAAA;ACDF;ADIA;EACE,aAAA;EACA,sBAAA;EACA,MAAA;EACA,WAAA;ACDF;ADIA;EACE,WAAA;ACDF;ADIA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,WAAA;ACDF;ADIA;;EAEE,2DAAA;EACA,4DAAA;ACDF","sourcesContent":["@import \"@/styles/breakpoint-mixin.scss\";\n\n.message-thread {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.message-thread__preview {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.message-thread__message {\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: flex-start;\n  gap: 6px;\n}\n\n.message-thread__message-details {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  width: 100%;\n}\n\n.message-thread__message-body {\n  display: flex;\n  width: 100%;\n}\n\n.message-thread__text {\n  color: #111827;\n  font-size: 14px;\n  line-height: 20px;\n}\n\n.message-thread__reply-count {\n  display: flex;\n  align-items: center;\n  flex-wrap: nowrap;\n  gap: 12px;\n}\n\n.message-thread__reply-count-text {\n  font-size: 14px;\n  color: #6b7280;\n  white-space: nowrap;\n}\n\n.message-thread__divider {\n  flex: 1;\n  height: 1px;\n  background-color: #e5e7eb;\n}\n\n.message-thread__replies {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.message-thread__empty {\n  display: flex;\n  justify-content: center;\n  padding: 16px;\n  color: #6b7280;\n}\n\n.message-thread__reply {\n  display: flex;\n}\n\n.message-thread__reply-container {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n  width: 100%;\n}\n\n.message-thread__message--reply {\n  width: 100%;\n}\n\n.message-thread__editor {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  width: 100%;\n}\n\n.message-thread__message,\n.message-thread__reply-container {\n  padding-left: v-bind(\"$getStyles.containerPadding\");\n  padding-right: v-bind(\"$getStyles.containerPadding\");\n}\n",".message-thread {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.message-thread__preview {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.message-thread__message {\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: flex-start;\n  gap: 6px;\n}\n\n.message-thread__message-details {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  width: 100%;\n}\n\n.message-thread__message-body {\n  display: flex;\n  width: 100%;\n}\n\n.message-thread__text {\n  color: #111827;\n  font-size: 14px;\n  line-height: 20px;\n}\n\n.message-thread__reply-count {\n  display: flex;\n  align-items: center;\n  flex-wrap: nowrap;\n  gap: 12px;\n}\n\n.message-thread__reply-count-text {\n  font-size: 14px;\n  color: #6b7280;\n  white-space: nowrap;\n}\n\n.message-thread__divider {\n  flex: 1;\n  height: 1px;\n  background-color: #e5e7eb;\n}\n\n.message-thread__replies {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.message-thread__empty {\n  display: flex;\n  justify-content: center;\n  padding: 16px;\n  color: #6b7280;\n}\n\n.message-thread__reply {\n  display: flex;\n}\n\n.message-thread__reply-container {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n  width: 100%;\n}\n\n.message-thread__message--reply {\n  width: 100%;\n}\n\n.message-thread__editor {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  width: 100%;\n}\n\n.message-thread__message,\n.message-thread__reply-container {\n  padding-left: v-bind(\"$getStyles.containerPadding\");\n  padding-right: v-bind(\"$getStyles.containerPadding\");\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
